<ng-container *transloco="let t">
  @if (canShow) {
    <div
      class="app-header"
      [ngClass]="{ 'has-warning-header': localStorageService.storageWarning() }"
    >
      <!--App Topbar-->
      <div class="app-topbars">
        <div class="app-topbar">
          <div class="app-topbar__dropdown">
            <app-group-dropdown-wrapper
              [groups]="visibleGroups"
              [selectedGroup]="selectedGroup"
              [groupSelectorTooltip]="groupSelectorTooltip"
              [groupTab]="groupTab"
            ></app-group-dropdown-wrapper>
            <div class="grey-vert-line"></div>
          </div>
          <div class="app-topbar__dropdown">
            <app-account-dropdown-wrapper
              [session]="session"
              [accountCounts]="accountCounts"
              [account]="account"
              [appVersion]="appVersion"
              [userTimezone]="userTimezone"
              (homepageChanged)="onHomepageChanged($event)"
              (openChangeTimezone)="openChangeTimezone()"
              (openChangeLanguage)="onOpenChangeLanguage()"
            ></app-account-dropdown-wrapper>
            <div class="grey-vert-line"></div>
            <div class="app-topbar__icons-right">
              @if (!authService.isSharedSession) {
                <div>
                  <a
                    [routerLink]=""
                    (click)="showDownloads()"
                    matTooltip="{{ t('app.see-downloads') }}"
                    ><img
                      role="button"
                      src="../assets/kitchen/icons/download.svg"
                      class="app-topbar__download-icon"
                  /></a>
                </div>
              }
              <div>
                <a
                  href="https://lexalytics.com/support"
                  target="_blank"
                  matTooltip="{{ t('app.support') }}"
                  ><img
                    role="button"
                    src="../assets/icons/xi-icons/question-mark.svg"
                    class="app-topbar__question-icon"
                /></a>
              </div>
              <div>
                <a
                  href="https://spotlight-docs.lexalytics.com/docs"
                  target="_blank"
                  matTooltip="{{ t('app.documentation') }}"
                  ><img
                    role="button"
                    src="../assets/kitchen/icons/document.svg"
                    class="app-topbar__document-icon"
                /></a>
              </div>
              @if (!authService.isSharedSession) {
                <div>
                  <a [routerLink]="" (click)="goHome()" matTooltip="{{ t('app.go-home') }}"
                    ><img
                      role="button"
                      src="../assets/kitchen/icons/app_home.svg"
                      class="app-topbar__home-icon"
                  /></a>
                </div>
              }
              @if (authService.isSSOUser && authService.nickname === 'inmoment') {
                <div class="divider"></div>
              }
              @if (authService.isSSOUser && authService.nickname === 'inmoment') {
                <div>
                  <a [routerLink]="" (click)="goToXI()" matTooltip="{{ t('app.go-xi') }}"
                    ><img
                      role="button"
                      src="../assets/inmoment_favicon_blue.svg"
                      class="app-topbar__home-icon"
                  /></a>
                </div>
              }
            </div>
          </div>
        </div>
        @if (localStorageService.storageWarning()) {
          <div class="storage-usage-warning">
            <ng-container
              *appMiddleEllipsize="
                t('storage-usage-warning', { percentUsed: localStorageService.percentUsed() });
                useHtml: true;
                tooltip: t('storage-useage-tooltip')
              "
            ></ng-container>
          </div>
        }
        <!-- App Nav menu-->
        @if (navbarDataLoaded) {
          <div>
            <!-- Lexalytics logo will be passed in when available in Kitchen-->
            <div class="spotlight-app-icon">
              <img width="40" height="40" src="../assets/spotlight_white.svg" />
            </div>
            <xi-app-title-bar
              appIcon="coach_white"
              text="Spotlight"
              color="CX"
              [isTextButton]="false"
            >
              <div slot="children" class="nav-bar">
                <div class="blue-vert-line"></div>
                <xi-horizontal-tab-bar
                  [stretch]="true"
                  contrast="high"
                  [hasTransparentBackground]="true"
                  [data]="tabMenu"
                  (onTabChange)="onTabChange($event)"
                  [activeTabId]="activeTab"
                >
                </xi-horizontal-tab-bar>
              </div>
            </xi-app-title-bar>
          </div>
        }
      </div>
      <div class="page-content"></div>
    </div>
  }

  <div
    class="app-router-content"
    @routerTransition
    [ngClass]="{ 'has-warning-header': localStorageService.storageWarning() }"
  >
    <otel-instrumentation></otel-instrumentation>
    <router-outlet #routerOutlet="outlet"></router-outlet>
  </div>

  <!--Snack Bar-->
  <app-lex-xi-snack-bar [snackbarData]="snackbarData"></app-lex-xi-snack-bar>

  <!--Timezone Modal-->
  @if (showTimezoneModal) {
    <app-lex-xi-modal
      [isVisible]="showTimezoneModal"
      [canBackdropClose]="false"
      maxWidth="500px"
      (close)="onTimezoneModalClosed('')"
    >
      <ng-template appXIModalContent>
        @if (showTimezoneModal) {
          <app-account-change-timezone
            [options]="{
              currentValue: userTimezone,
              defaultValue: timezoneService.defaultTimezone,
            }"
            (modalClosed)="onTimezoneModalClosed($event)"
          ></app-account-change-timezone>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  <!-- Language Modal -->
  @if (isChangeLanguageModalOpen) {
    <app-lex-xi-modal
      [isVisible]="isChangeLanguageModalOpen"
      maxWidth="500px"
      (close)="onCloseChangeLanguage(null)"
    >
      <ng-template appXIModalContent>
        @if (isChangeLanguageModalOpen) {
          <app-change-language
            [langCode]="userLangCode"
            (close)="onCloseChangeLanguage($event)"
          ></app-change-language>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showDownloadCenter) {
    <app-download-center [open]="showDownloadCenter" (close)="onDownloadCenterClosed()">
    </app-download-center>
  }

  <!-- Mobile Mode Selector (post-login interstitial) -->
  @if (showMobileModeSelector) {
    <app-mobile-mode-selector (modeSelected)="onMobileModeSelected($event)">
    </app-mobile-mode-selector>
  }

  <!-- AI Assistant (globally available) -->
  <app-spotlight-assistant></app-spotlight-assistant>
</ng-container>
